import { render, staticRenderFns } from "./shipmentsDialog.vue?vue&type=template&id=5833f13e&scoped=true"
import script from "./shipmentsDialog.vue?vue&type=script&lang=js"
export * from "./shipmentsDialog.vue?vue&type=script&lang=js"
import style0 from "./shipmentsDialog.vue?vue&type=style&index=0&id=5833f13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5833f13e",
  null
  
)

export default component.exports